import { IMakeRequest } from '../../utils/make_request';
import { parseResponse } from './helpers';
import { mergeBaseUri, mergePaths } from '@cian/http-api/shared';

export interface IValues {
  objectId?: number;
  personsCount: number;
  personsInfo: string;
  childrenCount: number;
  childrenInfo: string[];
  petsCount: number;
  petsInfo: string;
  comment: string;
  activityScope: string;
  name: string;
  isAgent: boolean;
  phone: string;
  smsCode?: string;
}

export function saveForm(makeRequest: IMakeRequest, apiBaseUrl: string, values: IValues) {
  return makeRequest({
    method: 'POST',
    body: JSON.stringify(values),
    uri: mergeBaseUri(apiBaseUrl, {
      path: (path: string) => mergePaths(path, '/v1/save-form/'),
    }),
    withCredentials: true,
    headers: [['Content-Type', 'application/json']],
  }).then(parseResponse('Не удалось отправить анкету. \n Попробуйте еще раз'));
}
